import Phaser from 'phaser';
import ABCyaPhaser, { Images as ABCyaImages, Buttons as ABCyaButtons, Audio as ABCyaAudio } from '@abcya/abcya_phaser';
import SoundAssetKeys from '../SoundAssetKeys';
import UIAssetKeys from '../UIAssetKeys';
import FontKeys from '../FontKeys';

export default class InstructionsPopup extends Phaser.GameObjects.Container {
  constructor (scene) {
    super(scene);

    this.background = ABCyaImages.addImage(0, 0, UIAssetKeys._InstructionsPopup, this).setOrigin(0);
    this.background.setInteractive();
    this.background.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () => {
      this.destroy();
    });

    const textWidth = 340;

    // create the instructions text
    const first = ABCyaPhaser.Text.addText(171,74,24, 0xcb00d1, FontKeys._linotte_bold, ABCyaPhaser.Localization.instance.getLocalizedString('instructions_popup.first'), this, false).setOrigin(0)
      .setWordWrapWidth(textWidth);
    const second = ABCyaPhaser.Text.addText(171,178,24, 0xcb00d1, FontKeys._linotte_bold, ABCyaPhaser.Localization.instance.getLocalizedString('instructions_popup.second'), this, false).setOrigin(0)
      .setWordWrapWidth(textWidth);
    const third = ABCyaPhaser.Text.addText(171,288,24, 0xcb00d1, FontKeys._linotte_bold, ABCyaPhaser.Localization.instance.getLocalizedString('instructions_popup.third'), this, false).setOrigin(0)
      .setWordWrapWidth(textWidth);
    const fourth = ABCyaPhaser.Text.addText(171,396,24, 0xcb00d1, FontKeys._linotte_bold, ABCyaPhaser.Localization.instance.getLocalizedString('instructions_popup.fourth'), this, false).setOrigin(0)
      .setWordWrapWidth(textWidth);

    this.addCloseButton();
  };

  addCloseButton() {

    const removeFunction = () => {
      this.destroy();
    };

    const closeButton = ABCyaButtons.addButton(287,510, UIAssetKeys._CloseBtn, UIAssetKeys._CloseBtn, SoundAssetKeys._click, removeFunction, this);

    return closeButton;

  }
}